module.exports = __webpack_public_path__ + "img/opala.70b52f3b.png";